module.exports = __webpack_public_path__ + "images/837f6653a3f1da38276b39a43a313de4.png";